import React from "react";
import TopSection from "./TopSection";
import VisionMission from "./VisionMission";
import WhatDriveus from "./WhatDriveus";
import MakeDifference from "../Reusable/MakeDifference";
import SEO from "../SEO";
import { useEffect } from "react";
import ReactGA  from "react-ga4";

const About = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/about",
      title: "About SynergyCare Foundation",
    });
  });
	return (
		<div className='py-16 relative'>
			<SEO
				title='About SynergyCare Foundation'
				description='Learn about SynergyCare Foundation, a nonprofit dedicated to bridging healthcare gaps for under-served communities.'
				name='SynergyCare Foundation'
				type=''
			/>

			<TopSection />
			<VisionMission />
			<WhatDriveus />
			<MakeDifference
				title1={"Ready To make a"}
				title2={" Difference? "}
				description={
					"Join our team of volunteers who are making a direct impact on under-served communities. Your time can change lives!"
				}
			/>
		</div>
	);
};

export default About;
